// extracted by mini-css-extract-plugin
export default {"root":"root--yJll1ztQzl","path":"path--swUm4jqYBg","trail":"trail--6CBMlsbgTS","text":"text--90c8fP1XQV","background":"background--nDHRRoQPng"};